import Modal from 'components/ui/Modal/Modal'
import BimLinkInput from './BimLinkInput'
import { CustomButton } from 'components/ui'
import { useAddBimLinkToTipo } from 'context/AddBimLinkToTipoContext'
import HistoricalTipoBimlink from './HistoricalTipoBimlink'


const ModalAddBimlinkTipo = ({ handleOnClose, tipo }) => {
  const { selectedBimlink, createTipo } = useAddBimLinkToTipo()

  const handleOnClick = async () => {
    await createTipo()
    handleOnClose()
  }
    
  return (
    <Modal
      modalClass="modal"
      containerChildrenClass="new-bimlink-container-modal min-width-500px max-width-500px"
      onClose={handleOnClose}
    >
      <div className="modal-link-bimlink-to-tipo-container">
        <div className="modal-link-bimlink-to-tipo-content">
          <div className="modal-link-bimlink-to-tipo-title-container">
            <h2>{tipo.name}</h2>
            <h3>Vincular BimLink con tipo</h3>
          </div>
          <div className='bimlink-input-wrapper'>

           <BimLinkInput />

          </div>
          <HistoricalTipoBimlink name={tipo.name} />
        </div>
        <div className="modal-link-bimlink-to-tipo-buttons">
          <CustomButton type="secondary" onClick={handleOnClose}>
            Cancelar
          </CustomButton>
          <CustomButton disabled={!selectedBimlink} onClick={handleOnClick}>
            Añadir bimlink
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAddBimlinkTipo
